'use client'

import Link from 'next/link'

import {
  AnalyticsEntityType,
  AnalyticsSource,
} from '@b-stock/fe-core/bstock-react'

import ComponentErrorBoundary from '@/helpers/ComponentErrorBoundary'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'

import type { Seller } from './getSellerSpotlightData'
import * as Styled from './ui'

type SellerSpotlightCard = {
  children: React.ReactNode
  seller: Seller
}

const SellerSpotlightCard = ({ children, seller }: SellerSpotlightCard) => {
  const analytics = useAnalytics()

  const handleClickSeller = () => {
    // Segment analytics event and metadata transcribed from old wordpress code
    // TODO: Update entity_type to based on the role of the user once we
    // implement user authentication.
    analytics.trackButtonClicked({
      screenName: 'homepage',
      buttonName: 'homepage_seller',
      source: AnalyticsSource.HOME_PORTAL,
      entityType: AnalyticsEntityType.BUYER,
      url: document.URL,
      referrer: document.referrer,
      seller_name_ua: seller.name.toLowerCase().replace(/\s+/g, '_'),
      cta_url: seller.link,
    })
  }

  return (
    <ComponentErrorBoundary>
      <Styled.Card
        $bgColor={seller.color}
        href={seller.link}
        as={seller.link.startsWith('/buy') ? Link : 'a'}
        onClick={handleClickSeller}
        target="_blank"
        rel="noopener"
      >
        {children}
      </Styled.Card>
    </ComponentErrorBoundary>
  )
}

export default SellerSpotlightCard
